import { handleLogout } from "authProvider";
import axios, { AxiosRequestConfig } from "axios";
import { BFF_KEY, TOKEN_KEY } from "environment";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((request: AxiosRequestConfig) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!request.headers) request.headers = {};

  request.headers["ocp-apim-subscription-key"] = BFF_KEY;

  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      handleLogout();

      const currentPath = window.location.pathname;

      if (currentPath !== "/login") window.location.href = "/login";

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export { axiosInstance };
